import axios from 'axios';
import { clearAuthToken, getStoredAuthToken } from '../utils/Auth';
import { getStoredLanguage } from '../utils/Language';
import { Language } from '../interfaces/Language';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL?.trim() || '/api',
});

export class UnauthorizedError extends Error {
  constructor() {
    super('Unauthorized');
    this.name = 'UnauthorizedError';
  }
}

const isLoginRequest = (url?: string) => url === '/auth/login';

api.interceptors.request.use((request) => {
  const token = getStoredAuthToken();

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  return request;
});

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    if (err?.response?.status === 401 && !isLoginRequest(err?.config?.url)) {
      clearAuthToken();
      throw new UnauthorizedError();
    }

    if (err?.response?.data?.message) {
      throw new Error(err.response.data.message);
    }
    if (err?.response?.data?.messages) {
      const messages = err.response.data.messages;
      throw new Error(
        messages[getStoredLanguage()] ??
          messages[Language.TR] ??
          'Unknown API error.',
      );
    }
    throw new Error('Unknown API error.');
  },
);

export default api;
